import { BigNumber, ethers } from 'ethers';

export const getTokenIdFromMintLogs = async (
    logs: ethers.providers.Log[],
    contract: ethers.Contract
): Promise<BigNumber | null> => {
    const mintEvent = logs.map((logs) => contract.interface.parseLog(logs)).find((log) => log.name === 'Mint');
    if (mintEvent) {
        const result = mintEvent.args;
        const tokenId: BigNumber = result.tokenId;
        return tokenId;
    }
    return null;
};

export const getTokenIdFromTransferLogs = async (
    logs: ethers.providers.Log[],
    contract: ethers.Contract
): Promise<BigNumber | null> => {
    const transferEvent = logs.map((logs) => contract.interface.parseLog(logs)).find((log) => log.name === 'Transfer');
    if (transferEvent) {
        const result = transferEvent.args;
        const tokenId: BigNumber = result.tokenId;
        return tokenId;
    }
    return null;
};
